module.exports = __webpack_public_path__ + "img/5.b0612be0.jpg";